import { combineReducers } from 'redux';

import {
    REQUEST_UPDATE_PROFILE,
    SUCCESS_UPDATE_PROFILE,
    FAILURE_UPDATE_PROFILE,
    RESET_FORM_SUBMIT_UPDATE_PROFILE
} from './constants';

/** State shape
 * {
    fetching: false,
    successProfileUpdateRequestSubmit: false,
    errorMessage: ''
 * }
 */

const successProfileUpdateRequestSubmit = (state = false, action) => {
    switch (action.type) {
        case SUCCESS_UPDATE_PROFILE:
            return true;
        case REQUEST_UPDATE_PROFILE:
        case FAILURE_UPDATE_PROFILE:
        case RESET_FORM_SUBMIT_UPDATE_PROFILE:
            return false;
        default:
            return state;
    }
};

const fetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_UPDATE_PROFILE:
            return true;
        case FAILURE_UPDATE_PROFILE:
        case SUCCESS_UPDATE_PROFILE:
        case RESET_FORM_SUBMIT_UPDATE_PROFILE:
            return false;
        default:
            return state;
    }
};

const error = (state = '', action) => {
    switch (action.type) {
        case FAILURE_UPDATE_PROFILE:
            return action.response.message;
        case REQUEST_UPDATE_PROFILE:
        case SUCCESS_UPDATE_PROFILE:
        case RESET_FORM_SUBMIT_UPDATE_PROFILE:
            return '';
        default:
            return state;
    }
};

export default combineReducers({ successProfileUpdateRequestSubmit, fetching, error });



// WEBPACK FOOTER //
// ./src/services/account/myprofile/reducer.js